<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('RECORDDATETIME')">
        <inputvalidation :formerror="formError" name="recordDateTime">
          <lb-vue-datetimepicker
            v-model="formData.recordDateTime"
            :translate-method="translateDateTimePicker"
            format="YYYY-MM-DD HH:mm:ss"
            display-format="DD.MM.YYYY HH:mm:ss"
            :isUTC="true"
            :simple="true">
            </lb-vue-datetimepicker>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('THERAPYTYPE')">
        <inputvalidation :formerror="formError" name="therapyTypeId">
             <lb-vue-select v-model= "formData.terapyId"
                            :list= "therapyType.root"
                            :totalCount= "therapyType.totalCount"
                            :pagination= "pagination"
                            display-field= "name"
                            value-field= "therapyTypeId"
                            :search-placeholder= "$t('SEARCH')"
                            :items-placeholder= "$t('THERAPYTYPE')">
              </lb-vue-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('WORKTYPE')">
        <inputvalidation :formerror="formError" name="workTypeId">
             <lb-vue-select v-model= "formData.workTypeId"
                            :list= "workType.root"
                            :totalCount= "workType.totalCount"
                            :pagination= "paginationWorkType"
                            display-field= "workType"
                            value-field= "workTypeId"
                            multiselect="true"
                            :search-placeholder= "$t('SEARCH')"
                            :items-placeholder= "$t('WORKTYPE')">
              </lb-vue-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('DESCRIPTION')">
        <inputvalidation :formerror="formError" name="description">
          <b-form-textarea v-model="formData.description" type="text" :rows="3" :max-rows="6"></b-form-textarea>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('PARENTNOTE')">
        <inputvalidation :formerror="formError" name="parentNote">
          <b-form-textarea v-model="formData.parentNote" type="text" :rows="3" :max-rows="6"></b-form-textarea>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('AMOUNT')">
        <inputvalidation :formerror="formError" name="amount">
          <b-form-input type="number" v-model="formData.amount"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
       <b-form-fieldset v-bind:label="$t('ISPAYED')">
          <inputvalidation :formerror="formError" name="isPayed">
              <b-form-select v-model="formData.isPayed" :options="options"></b-form-select>
          </inputvalidation>
        </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
import Api from '@/api/therapy/TherapyType';
import WorkTypeApi from '@/api/worktype/WorkType';

export default
{
    name: 'ArrivalRecordForm',
    props: ['formData', 'formError'],
    data()
    {
        const me = this;
        return {
            therapyType: {},
            workType: {},
            options: [
                { value: 'prepared', text: '' },
                { value: 'payed', text: me.$t('PAYED') },
                { value: 'callof', text: me.$t('CALLOF') },
                { value: 'canceled', text: me.$t('CANCELED') },
            ],
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
      },
            paginationWorkType:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
          initialId: [],
      },
        };
    },
    created()
    {
        const me = this;
        me.getData();
        me.getWorkType();
    },
    methods:
  {
      async getData()
      {
          const me = this;
          try
          {
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  return;
              }

              me.therapyType = data;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async getWorkType()
      {
          const me = this;
          try
          {
              const data = await WorkTypeApi.selectRow(me.getParamsSec);
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  return;
              }

              me.workType = data;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      translateDateTimePicker(val)
      {
          const me = this;
          return me.$t(val.toUpperCase());
      },
  },
    watch:
  {
      'pagination.limit'()
      {
          const me = this;
          me.getData();
      },
      'pagination.currentPage'()
      {
          const me = this;
          me.getData();
      },
      'pagination.query'()
      {
          const me = this;
          me.getData();
      },
      'paginationWorkType.limit'()
      {
          const me = this;
          me.getWorkType();
      },
      'paginationWorkType.currentPage'()
      {
          const me = this;
          me.getWorkType();
      },
      'paginationWorkType.query'()
      {
          const me = this;
          me.getWorkType();
      },
  },
    computed:
  {
      getParams()
      {
          const me = this;
          const data = {
              ...me.pagination,
          };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      getParamsSec()
      {
          const me = this;
          const data = {
              ...me.paginationWorkType,
          };

          if (me.formData.workTypeId != null)
          {
              if (typeof me.formData.workTypeId === 'string')
              {
                  data.initialId = me.formData.workTypeId.split(',');
              }
              else
              {
                  data.initialId = me.formData.workTypeId;
              }
          }

          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
